/**
 * 拓扑插件-常量、图形等各项参数配置
 */

// 通用常量
import elementNameConst from './constants/element_name_const';
import layoutNameConst from './constants/layout_name_const';
import * as eventNameConst from './constants/event_name_const';
import identityConst from './constants/identity_const';
import shapeTypeConst from './constants/shape_type_const';
import btnEventCodeConst from './constants/btn_event_code_const';
import * as behaviorConst from './constants/behavior_const';
import * as pluginConst from './constants/plugin_const';
import modesConst from './constants/modes_const';
import stateConst from './constants/state_const';
import dataConst from './constants/data_const';


// 样式
import * as nodeStyle from './constants/style/node_style_const';
import * as edgeStyle from './constants/style/edge_style_const';


export {
  elementNameConst,
  layoutNameConst,
  eventNameConst,
  identityConst,
  shapeTypeConst,
  btnEventCodeConst,
  behaviorConst,
  pluginConst,
  modesConst,
  stateConst,
  dataConst,

  // 样式
  nodeStyle,
  edgeStyle
};
